import React, { Component } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import Icon from '../icon/icon';
import styles from './titleBar.css';

export const defaultBackText = 'back';

export default class TitleBar extends Component {
  render() {
    const { className, headerClassName, back, backText = defaultBackText, title, button } = this.props;

    return (
      <div className={cn(className, 'flex pb3 pb3-m pb4-l items-center content')}>
        <div className="flex flex-column flex-grow-1">
          {!!back && (
            <Link className={`${styles.link} mb3 fs2`} to={back}>
              <Icon className={`${styles.icon} mr2`} icon="chevron-left" />
              <span>{backText}</span>
            </Link>
          )}
          <h2 data-qa="title" className={cn('h4 ma0 pa0 h-auto flex-grow-1', headerClassName)}>
            {title}
          </h2>
        </div>
        {button && button}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/titleBar/titleBar.jsx